const SET_THEME = 'SET_THEME';

export {
    SET_THEME
}